import { useState } from "react";
import styles from "./site-card.module.css";

import Botones from "../botones/botones";

import vectorRectangle1Default from "../../assets/img/vectors6442.svg";
import vectorRectangle3Default from "../../assets/img/vectors6445.svg";

function s22NovemberDefault(props) {
	if (props.hasOwnProperty("s22November")) {
		return props.s22November;
	} else if (props.hasOwnProperty("defaultTexts") && props.defaultTexts === "on") {
		return "22 November"; 
	}
	return " ";
}
function designDefault(props) {
	if (props.hasOwnProperty("design")) {
		return props.design;
	} else if (props.hasOwnProperty("defaultTexts") && props.defaultTexts === "on") {
		return "Design"; 
	}
	return " ";
}
function top10ProductDesignIdeasDefault(props) {
	if (props.hasOwnProperty("top10ProductDesignIdeas")) {
		return props.top10ProductDesignIdeas;
	} else if (props.hasOwnProperty("defaultTexts") && props.defaultTexts === "on") {
		return "Top 10 product design ideas"; 
	}
	return " ";
}
function vectorRectangle1SrcDefault(props) {
	if (props.hasOwnProperty("vectorRectangle1Src")) {
		return props.vectorRectangle1Src;
	} else if (props.hasOwnProperty("defaultImages") && props.defaultImages === "on") {
		return vectorRectangle1Default;
	} 
	return 'data:image/svg+xml;charset=utf-8, <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg"><rect width="100%" height="100%" style="fill-opacity:0;" /></svg>';
} 
function vectorRectangle3SrcDefault(props) {
	if (props.hasOwnProperty("vectorRectangle3Src")) {
		return props.vectorRectangle3Src;
	} else if (props.hasOwnProperty("defaultImages") && props.defaultImages === "on") {
		return vectorRectangle3Default;
	} 
	return 'data:image/svg+xml;charset=utf-8, <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg"><rect width="100%" height="100%" style="fill-opacity:0;" /></svg>';
} 

export default function SiteCard(props) {
	let id = "";
	let defaultTexts = "off";
	let defaultImages = "off";
	if (props.id) {
		id = props.id;
	}
	if (props.defaultTexts) {
		defaultTexts = props.defaultTexts;
	}
	if (props.defaultImages) {
		defaultImages = props.defaultImages;
	}

	const [wcfHighlight, setwcfHighlight] = useState("off");					// for app-demo highlight

	const [s22November, sets22November] = useState(() => s22NovemberDefault(props));
	const [design, setdesign] = useState(() => designDefault(props));
	const [top10ProductDesignIdeas, settop10ProductDesignIdeas] = useState(() => top10ProductDesignIdeasDefault(props));
	const [vectorRectangle1Src, setvectorRectangle1Src] = useState(() => vectorRectangle1SrcDefault(props));
	const [vectorRectangle3Src, setvectorRectangle3Src] = useState(() => vectorRectangle3SrcDefault(props));

	document.addEventListener("wcfSubcompsService", (e) => {
		if (e.detail.id && e.detail.id === id) {
			if (e.detail.hasOwnProperty("wcfHighlight")) {
				setwcfHighlight(e.detail.wcfHighlight);
			}
			if (e.detail.hasOwnProperty("s22November")) {
				sets22November(e.detail.s22November);
			}
			if (e.detail.hasOwnProperty("design")) {
				setdesign(e.detail.design);
			}
			if (e.detail.hasOwnProperty("top10ProductDesignIdeas")) {
				settop10ProductDesignIdeas(e.detail.top10ProductDesignIdeas);
			}
			if (e.detail.hasOwnProperty("vectorRectangle1Src")) {
				setvectorRectangle1Src(e.detail.vectorRectangle1Src);
			}
			if (e.detail.hasOwnProperty("vectorRectangle3Src")) {
				setvectorRectangle3Src(e.detail.vectorRectangle3Src);
			}
		}
	});

	let wcfHighlightClass;
	if (wcfHighlight == "on") {
		wcfHighlightClass = styles["wcfHighlightClass"];
	} else {
		wcfHighlightClass = "";
	}	


	return (
		<div
		   id="63:152"
		   dataName="site-card"
		   dataComponentId="site-card"
		   className={styles["css-site_card"]+" "+styles["site_card"]+" "+wcfHighlightClass}
		   dataWcfid="site_card">
			<img
			   src={vectorRectangle1Src}
			   width="235px"
			   height="123px"
			   id="64:42"
			   dataName="vector-rectangle-1"
			   className={styles["css-Vector_Rectangle_1"]+" "+styles["vector_rectangle_1"]}
			   dataWcfid="vector_rectangle_1" />
			<div
			   id="63:135"
			   dataName="frame-102"
			   className={styles["css-Frame_102"]+" "+styles["frame_102"]}
			   dataWcfid="frame_102">
				<div
				   id="63:136"
				   dataName="frame-101"
				   className={styles["css-Frame_101"]+" "+styles["frame_101"]}
				   dataWcfid="frame_101">
					<div
					   id="63:137"
					   dataName="frame-99"
					   className={styles["css-Frame_99"]+" "+styles["frame_99"]}
					   dataWcfid="frame_99">
						<p
						   id="63:138"
						   dataName="s22-november"
						   className={styles["css-s_22_November"]+" "+styles["s22_november"]}
						   dataWcfid="s22_november">
							{s22November}
						</p>
						<img
						   src={vectorRectangle3Src}
						   width="10px"
						   height="10px"
						   id="64:45"
						   dataName="vector-rectangle-3"
						   className={styles["css-Vector_Rectangle_3"]+" "+styles["vector_rectangle_3"]}
						   dataWcfid="vector_rectangle_3" />
						<p
						   id="63:140"
						   dataName="design"
						   className={styles["css-Design"]+" "+styles["design"]}
						   dataWcfid="design">
							{design}
						</p>
					</div>
					<p
					   id="63:141"
					   dataName="top-10-product-design-ideas"
					   className={styles["css-Top_10_product_design_ideas"]+" "+styles["top_10_product_design_ideas"]}
					   dataWcfid="top_10_product_design_ideas">
						{top10ProductDesignIdeas}
					</p>
				</div>
				<div
				   id="63:142"
				   dataName="frame-100"
				   className={styles["css-Frame_100"]+" "+styles["frame_100"]}
				   dataWcfid="frame_100">
					<Botones
					   id={id + ".botones"}
					   defaultTexts={defaultTexts}
					   defaultImages={defaultImages}>
					</Botones>
					<Botones
					   id={id + ".botones_1"}
					   defaultTexts={defaultTexts}
					   defaultImages={defaultImages}>
					</Botones>
					<Botones
					   id={id + ".botones_2"}
					   defaultTexts={defaultTexts}
					   defaultImages={defaultImages}>
					</Botones>
				</div>
			</div>
		</div>
	)

}
